import styled from 'styled-components/macro';
import { COLORS, BOX_SHADOW } from 'styleguide';
import SimpleList from './SimpleList';

const DropdownList = styled(SimpleList)`
  padding: 16px 0;
  border-radius: 4px;
  box-shadow: ${BOX_SHADOW.dropdown};
  background-color: ${COLORS.line};
`;

export default DropdownList;
